import type { VueConstructor } from "vue";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import { BlipToken } from "@space-oddity-inc/editor-core";
import TokenChip from "./TokenChip.vue";

/**
 * core BlipToken에 Vue NodeView(칩 시각화)만 주입한다.
 * renderHTML/parseHTML/attributes 등 직렬화 계약은 core 정의를 그대로 상속 →
 * 저장/출력 HTML 불변(서버 applyTabTokens 정규식 계약 유지).
 */
export const BlipTokenVue = BlipToken.extend({
  addNodeView() {
    // Vue 2.7 `defineComponent` 반환 타입(Vue3식)과 vue-2 바인딩이 기대하는
    // VueConstructor가 타입상 어긋난다(런타임은 정상). 단일 seam에서 캐스팅.
    return VueNodeViewRenderer(TokenChip as unknown as VueConstructor);
  },
});
